import {Component, Input} from '@angular/core';

/**
 * Generated class for the MemberHeadComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'member-head',
  templateUrl: 'member-head.html'
})
export class MemberHeadComponent {


  @Input() member;
  @Input() position;
  @Input() bigHead;

  constructor() {
    console.log('Hello MemberHeadComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/member-head/member-head.ts